import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import ModalQuestion from '../modal/ModalQuestion';
import ModalFilter from '../modal/ModalFilter';
import AlignEnum from './AlignEnum';
import TableTypeEnum from './TableTypeEnum';

import { route } from '../../../helper/Route';

class Table extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            
            modalFilter: false,
        }        
    }

    validarEditar() {
        return ((!this.props.disabled)&&
                (this.props.remover !== undefined || 
                    this.props.editar !== undefined || 
                    this.props.view !== undefined || 
                    this.props.callback !== undefined || 
                    this.props.actions !== undefined
            ));
    }

    editarTd(item, i ) {
        if(!this.validarEditar()) {
            return;
        }

        return (
            <th className="text-right">
                {
                    this.props.actions !== undefined &&
                    this.props.actions(item, i)
                }
                
                { 
                    this.props.callback !== undefined &&
                    <button 
                        type="button"                        
                        className="btnCallback"
                        onClick={() => this.props.onCallback(item)}
                    >
                        <i className="fas fa-exchange-alt"></i>
                    </button>
                }

                { 
                    this.props.editar === true &&
                    <button 
                        className="btnDefault"
                        type="button"                        
                        onClick={() => this.props.route(route(
                            '',
                            'Cadastro',
                            this.props.link + '/crud' + (item.id === undefined ? '?hash=' + item.uuid : '?id=' + item.id)
                        ))}
                    >
                        <i className="fa fa-wrench" />
                    </button>
                }

                { 
                    this.props.view === true &&
                    <button 
                        className="btnView"
                        type="button"                        
                        onClick={() => this.props.route(route(
                            '',
                            'View',
                            this.props.link + '/view' + (item.id === undefined ? '?hash=' + item.uuid : '?id=' + item.id)
                        ))}
                    >
                        <i className="far fa-eye"/>
                    </button>
                }

                { 
                    this.props.remover !== undefined &&
                    <button 
                        type="button"    
                        className="btnDanger"                         
                        style={{marginLeft: '5px'}}
                        onClick={() => this.setState({modal: true, removerItem: item, removerIndice: i})}
                    >
                        <i className="fa fa-times" />
                    </button>
                }                        
            </th>
        )
    }

    remover () {
        this.props.onRemover(this.state.removerItem, this.state.removerIndice);
        this.setState({modal: false})
    }    

    align(itemHead) {
        if(itemHead.align === undefined)
            return AlignEnum.LEFT.className;

        return itemHead.align.className;
    }

    exibiHeader(item) {         
        if(typeof item.nome === 'function')    
            return item.nome();
        
        return item.nome;
    } 
    
    getCampo(item, value) {
        const indiceIni = value.indexOf('[');        

        if(indiceIni === -1) {
            return item[value];
        }

        const indiceFim = value.indexOf(']');
        const indice = value.substring(indiceIni + 1, indiceFim);   
        const indiceInt = parseInt(indice, 10);

        value = value.substring(0, indiceIni);
        
        if(Number.isInteger(indiceInt)) {
            return item[value][indice];
        }        
    }

    getValue(item, itemHead) {
        let array = itemHead.campo.split('.');
        let result = '';

        array.forEach((value) => {
            if(result === '') {
                result = this.getCampo(item, value);
                return ;
            }

            if(result === undefined) {
                return ;
            }

            result = result[value];
        });

        return result;
    }

    exibeCampo(item, index, itemHead) {        
        if(itemHead.type === undefined) {            
            return this.getValue(item, itemHead);
        }
        
        let tableType = TableTypeEnum.get(itemHead.type.enumName);        
        
        if(itemHead.type === TableTypeEnum.CHECKBOX)            
            return <input type="checkbox" value={item[itemHead.campo]} readonly={itemHead.readonly} checked={item[itemHead.campo]} onClick={() => (itemHead.readonly ? null : this.props.onCheck(index))} />        

        if(itemHead.scale !== undefined)
            return tableType.format(item[itemHead.campo], itemHead.scale, itemHead.isInteger);                                     
                
        return tableType.format(this.getValue(item, itemHead)); 
    }

    className(item, itemHead) {
        if(this.props.onClassName === undefined)
            return '';

        return this.props.onClassName(item, itemHead);        
    }    
        
    showButtonNovo() {
        if(this.props.link) {
            return (
                <button 
                    type="button"    
                    className="btnPrimary"                         
                    style={{marginBottom: '15px'}}                            
                    onClick={() => this.props.route(route(
                            '',
                            'Cadastro',
                            this.props.link + '/crud'
                    ))}
                >
                    <i className="fa fa-plus"/> Novo
                </button>
            );
        }

        if(this.props.onClick !== undefined) {
            return (
                <button 
                    type="button"    
                    className="btnPrimary"                         
                    style={{marginBottom: '15px'}}                            
                    onClick={() => this.props.onClick()}
                >
                    <i className="fa fa-plus"/> Novo
                </button>
            );        
        }

        return ;
    }    

    render() {
        return (
            <div>      
                <ModalQuestion
                    show={this.state.modal}
                    styleIcon="fas fa-question-circle"
                    header="Pergunta"
                    texto={this.props.messageRemover}
                    
                    btnSimClick={() => this.remover()}
                    btnNaoClick={() => this.setState({ modal: false })}
                    fechar={() => this.setState({ modal: false })}
                />                

                <ModalFilter
                    show={this.state.modalFilter}
                    filter={this.props.filter}
                    filterService={this.props.filterService}
                    
                    onCallback={(filter, resposta, erro) => {this.props.onCallbackFilter(filter, resposta, erro); this.setState({modalFilter: false})}}                    
                    
                    fechar={() => this.setState({modalFilter: false})}
                />

                {
                    this.props.cadastro &&
                    this.showButtonNovo()
                }

                {
                    this.props.filtered &&                    
                    <button 
                        type="button"    
                        className="btn btn-primary"                         
                        style={{marginBottom: '15px'}}                            
                        onClick={() => this.setState({modalFilter: true})}
                    >
                        <i className="fas fa-filter"></i> Filtrar
                    </button>            
                }

                {
                    this.props.onCheckAll !== undefined &&
                    <button 
                        disabled={this.props.body.length === 0}
                        className="btn btn-info" style={{marginBottom: '15px'}}
                        onClick={() => this.props.onCheckAll()} 
                    >
                        <i className="fas fa-check" /> { (!this.props.checkAll ? 'Marcar' : 'Desmarcar') + ' Todos'}
                    </button>
                }

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                {this.props.head.map((item, i) => {
                                    return (
                                        <th 
                                            key={i}
                                            className={this.align(item)}
                                            width={item.width}
                                        >
                                            {this.exibiHeader(item)}
                                        </th>
                                    )
                                })}

                                {this.validarEditar() && <th className="col-md-2" />}
                            </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(this.props.body) && this.props.body.map((item, index) => {
                            return (
                            <tr key={index} className={(item.marcar ? 'table-checked' : '')}>
                                {this.props.head.map((itemHead, i) => {
                                    return (
                                        <td 
                                            key={i} 
                                            className={this.align(itemHead) + " " + this.className(item, itemHead)}
                                        >
                                            {this.exibeCampo(item, index, itemHead)}
                                        </td>
                                    )
                                })}

                                {this.editarTd(item, index)}
                            </tr>
                            )
                        })}
                        </tbody>
                    </table>                
                </div>
            </div>
        )
    }
}

Table.defaultProps = {
    codigo: 'id',
    disabled: false,
    messageRemover: "Tem certeza que deseja remover este registro?"    
};

export default  Table;